import { render, staticRenderFns } from "./UserRoleView.vue?vue&type=template&id=674dfc0d&"
import script from "./UserRoleView.vue?vue&type=script&lang=js&"
export * from "./UserRoleView.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleView.vue?vue&type=style&index=0&id=674dfc0d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports